import Avatar from '@/components/ui/Avatar';

interface AdminAvatarProps {
  name: string | null | undefined;
  email: string | null | undefined;
  /** Signed URL for the avatar; when absent (or it fails to load) we fall back to initials. */
  photoUrl?: string | null;
  /** Rendered square size in pixels. Default 40 (list/PIN). */
  size?: number;
  className?: string;
}

/**
 * The single avatar piece used on every admin surface (header, PIN switch, admin
 * list/detail, activity log). Thin wrapper over the generic <Avatar> — kept so
 * admin call sites stay stable. The photo/initials behavior (including the
 * URL-keyed load-failure retry) lives in <Avatar>.
 */
export default function AdminAvatar(props: AdminAvatarProps) {
  return <Avatar {...props} />;
}
